import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import { translate, LANGUAGES } from "../lib/translations";

const STORAGE_KEY = "refpair_lang";
const DEFAULT_LANG = "en";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
    const [lang, setLangState] = useState(() => {
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            if (stored && LANGUAGES.some((l) => l.code === stored)) return stored;
        } catch (e) { /* ignore */ }
        return DEFAULT_LANG;
    });

    useEffect(() => {
        try {
            localStorage.setItem(STORAGE_KEY, lang);
            document.documentElement.lang = lang;
        } catch (e) { /* ignore */ }
    }, [lang]);

    const setLang = useCallback((code) => {
        if (LANGUAGES.some((l) => l.code === code)) setLangState(code);
    }, []);

    const t = useCallback((key, vars) => translate(lang, key, vars), [lang]);

    const value = useMemo(() => ({ lang, setLang, t, languages: LANGUAGES }), [lang, setLang, t]);

    return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
    return ctx;
}
